import React, { useState, useEffect, useRef } from 'react';
import imgBgPhone from '../../assets/svg/phone_bg.svg';
import imgBgPhoneReview from '../../assets/svg/phone_bg.svg';
import imgBgPhoneReal from '../../assets/svg/phone_bg.svg';
import Slider from 'react-slick';
// IMG
import imgBgPhoneEcom from '../../assets/templates/img-ecommerce.svg';
import imgReaLEstate from '../../assets/webp/img_1.webp';
import imgAutimotive from '../../assets/webp/img_2.webp';
import img3 from '../../assets/webp/img_3.webp';
import imgReviews from '../../assets/webp/img_4.webp';

export default function Usecases() {
    const cardData = [
        {
            title: "COD E-Commerce",
            description: "You can send automated messages to confirm the delivery address and dates.",
            img: imgBgPhoneEcom,
        },
        {
            title: "Customer Reviews",
            description: "Effortlessly collect customer reviews and redirect those that provide positive ratings to leave feedback on platforms like Google Reviews and Trustpilot, boosting your online reputation.",
            img: imgReviews,
        },
        {
            title: "Real Estate Lead Generation",
            description: "Send automated messages to announce new projects, effectively reaching potential clients and generating valuable leads.",
            img: imgReaLEstate,
        },
        {
            title: "Automotive Deal Announcements",
            description: "Keep your customers informed about the latest deals to generate leads and boost sales. By regularly updating your clients with exciting offers, you can foster customer loyalty.",
            img: imgAutimotive,
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const containerRef = useRef(null); // Ref for the scrollable div

    // Auto-play functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => {
                // Determine the next index
                const nextIndex = (prevIndex + 1) % cardData.length; // Loop to the first card
    
                // Get the current and next card elements
                const nextCardElement = containerRef.current.children[nextIndex];
    
                if (nextCardElement) {
                    const cardOffsetTop = nextCardElement.offsetTop; // Get the position of the next card
                    const containerHeight = containerRef.current.clientHeight; // Height of the container
                    const cardHeight = nextCardElement.clientHeight; // Height of the next card
    
                    // Calculate the offset to center the active card
                    const scrollToPosition = cardOffsetTop - (containerHeight / 2) + (cardHeight / 2);
    
                    // Scroll to the next card, centering it
                    containerRef.current.scrollTo({
                        top: scrollToPosition,
                        behavior: 'smooth', // Smooth scroll to the next card
                    });
                }
    
                // If we reach the last card, scroll to the first card after showing the last one
                if (nextIndex === 0) {
                    setTimeout(() => {
                        if (containerRef.current) {
                            const firstCardElement = containerRef.current.children[0];
                            if (firstCardElement) {
                                const firstCardOffsetTop = firstCardElement.offsetTop; // Get the position of the first card
                                const containerHeight = containerRef.current.clientHeight; // Height of the container
                                const firstCardHeight = firstCardElement.clientHeight; // Height of the first card
    
                                // Calculate the offset to center the first card
                                const scrollToPosition = firstCardOffsetTop - (containerHeight / 2) + (firstCardHeight / 2);
    
                                // Scroll to the first card, centering it
                                containerRef.current.scrollTo({
                                    top: scrollToPosition,
                                    behavior: 'smooth', // Smooth scroll to the first card
                                });
                            }
                        }
                    }, 5000); // Delay to allow the last card to be displayed for a while
                }
    
                return nextIndex; // Update to the next index
            });
        }, 5000); // Adjusted interval to 5 seconds to match the delay for the last card
    
        return () => clearInterval(interval);
    }, [cardData.length]);
    
    
    
    

    const handleCardClick = (index) => {
        setActiveIndex(index);
    };

    const settingsSlider = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '5px',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <>
            <div id='use-cases' className='w-full h-full bg-gradient-to-r from-[#1B202A] to-[#171a24] pt-12 relative'>
                <h3 className='text-center font-bold text-white text-3xl mt-12'>Use cases</h3>
                <div className='hidden max-sm:block'>
                    <Slider {...settingsSlider}>
                        {cardData.map((card, index) => (
                            <div key={index} className="px-3 mx-auto">
                                <div className='py-6'>
                                    <h1 className="text-center text-white text-3xl font-bold mb-4">{card.title}</h1>
                                    <p className="text-center text-[#B4BCC8] text-base font-normal">{card.description}</p>
                                    <div className="flex items-center justify-center mt-4">
                                        <img className='w-[265px]' src={card.img} alt="" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>

                <div className="max-sm:hidden inset-0 flex items-center justify-center mt-20">
                    {/* Card Text Section */}
                    <div className="max-h-[755px] overflow-y-auto overflow-x-hidden" ref={containerRef}>
                        {cardData.map((card, index) => (
                            <div
                                key={index}
                                className={`block p-7 rounded-bl-3xl rounded-tl-3xl border-t-2 border-l-2 border-b-2 border-[#ffffff0e] mt-6 first:mt-0 
                                ${index === activeIndex ? 'active bg-[#ffffff09] max-h-[755px]' : 'bg-[#ffffff01]'} 
                                ${index === 0 ? 'rounded-t-md rounded-b-md' : ''}`}
                                style={{ cursor: 'pointer', width: '100%', transition: 'max-height 0.3s ease-in-out' }}
                                onClick={() => handleCardClick(index)}
                            >
                                <div className="max-w-lg">
                                    <h1 className="text-white">{card.title}</h1>
                                    <p className="text-[#B4BCC8] text-base mt-4">{card.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* Image Section */}
                    <img
                        className="max-sm:hidden max-sm:max-w-[265px] max-sm:mx-auto"
                        src={cardData[activeIndex].img} // Show image based on activeIndex
                        alt="Phone"
                    />
                </div>
                <div className="md:mt-[-90px] max-lg:mt-[-190px] max-xl:mt-[-100px] max-sm:mt-[-110px]"></div>
                <svg width="w-full" viewBox="0 0 1728 323" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2005_63)">
                        <path className='max-sm:hidden' d="M1040 93L1598 10V424H1040V93Z" fill="#AFD6A2" />
                        <path className='max-sm:hidden' d="M1170 93L1728 10V424H1170V93Z" fill="#DEA686" />
                        <path d="M-0.0803158 313.73L-0.5 313.798V314.223V1339V1339.5H0H1728H1728.5V1339V33V32.412L1727.92 32.5065L-0.0803158 313.73Z" fill="url(#paint0_linear_2005_63)" stroke="#2C3242" />
                    </g>
                    <defs>
                        <linearGradient id="paint0_linear_2005_63" x1="114.999" y1="552.476" x2="1858.4" y2="1002.11" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#1B202A" />
                            <stop offset="1" stopColor="#141821" />
                        </linearGradient>
                        <clipPath id="clip0_2005_63">
                            <rect width="1728" height="323" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </>
    );
}
